import { format } from "date-fns";
import { convertToDate, convertToTimestamp } from "./timestampUtils";

export const convertHistoricoGraduacoesValuesFromTimestamp = (historicoGraduacoes) => {
  // Verificar se historicoGraduacoes é undefined ou null
  if (!historicoGraduacoes) {
    return Array(19).fill("");
  }
  
  // Garantir que temos um array com o tamanho correto
  historicoGraduacoes = Array.isArray(historicoGraduacoes) ? historicoGraduacoes.slice(0, 19) : Array(19).fill("");
  
  // Se o array for menor que 19, completamos com strings vazias
  while (historicoGraduacoes.length < 19) {
    historicoGraduacoes.push("");
  }
  
  return historicoGraduacoes.map((historicoGraduacao) => {
    if (typeof historicoGraduacao === "string") return historicoGraduacao;
    else if (historicoGraduacao !== "") {
      const date = convertToDate(historicoGraduacao);
      if (date) {
        return format(date, "yyyy-MM-dd");
      } else {
        console.warn("Não foi possível converter data do histórico de graduações:", historicoGraduacao);
        return "";
      }
    }
    else return historicoGraduacao;
  });
};

export const convertHistoricoGraduacoesValuesToTimestamp = (historicoGraduacoes) => {
  // Verificar se historicoGraduacoes é undefined ou null
  if (!historicoGraduacoes) {
    return Array(19).fill("");
  }
  
  // Garantir que temos um array
  if (!Array.isArray(historicoGraduacoes)) {
    return Array(19).fill("");
  }
  
  return historicoGraduacoes.map((historicoGraduacao) => {
    if (historicoGraduacao !== "") {
      const timestamp = convertToTimestamp(new Date(historicoGraduacao + " 03:00:00"));
      return timestamp || historicoGraduacao;
    }
    else return historicoGraduacao;
  });
};
